export default "__VITE_ASSET__6e450cc8__"